import config from "../../config.js";
import axios from "axios";

const DEFAULT_ALERT_LIMIT = 100;

const ALERT_TAB_URLS = {
  all: `${config.baseURL}/alert/organization`,
  user: `${config.baseURL}/alert/organization/user`,
  vehicle: `${config.baseURL}/alert/organization/vehicle`,
  expiry: `${config.baseURL}/alert/organization/expiry`,
  starred: `${config.baseURL}/alert/starred`,
};

const parseHeaderNumber = (value, fallbackValue = null) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : fallbackValue;
};

export async function getAlertCounts() {
  const response = await axios.get(`${config.baseURL}/alert/counts`, {
    withCredentials: true,
  });
  return response.data;
}

export async function fetchAlertsTab(tabKey, cursor = null, limit = DEFAULT_ALERT_LIMIT) {
  const response = await axios.get(ALERT_TAB_URLS[tabKey], {
    params: {
      limit: Math.min(limit, DEFAULT_ALERT_LIMIT),
      ...(cursor != null ? { cursor } : {}),
    },
    withCredentials: true,
  });

  return {
    alerts: Array.isArray(response.data) ? response.data : [],
    hasMore: response.headers["x-alert-has-more"] === "true",
    nextCursor: parseHeaderNumber(response.headers["x-alert-next-cursor"]),
    limit: parseHeaderNumber(response.headers["x-alert-limit"], limit),
  };
}

export async function getAllAlerts(cursor = null, limit = DEFAULT_ALERT_LIMIT) {
  return fetchAlertsTab("all", cursor, limit);
}

export async function getUserAlerts(cursor = null, limit = DEFAULT_ALERT_LIMIT) {
  return fetchAlertsTab("user", cursor, limit);
}

export async function getVehicleAlerts(cursor = null, limit = DEFAULT_ALERT_LIMIT) {
  return fetchAlertsTab("vehicle", cursor, limit);
}

export async function getExpiryAlerts(cursor = null, limit = DEFAULT_ALERT_LIMIT) {
  return fetchAlertsTab("expiry", cursor, limit);
}
// Function to delete an alert
export async function deleteAlertById(alertId) {
  const response = await axios.delete(`${config.baseURL}/alert/delete`, {
    data: { id: alertId },
    withCredentials: true,
  });
  return response.data;
}

//function to update the alert
export async function updateAlert(alertData) {
  try {
    const updatedAlert = await axios.put(`${config.baseURL}/alert`, alertData, {
      withCredentials: true,
    });

    return updatedAlert.data;
  } catch (error) {
    console.error("Failed to update alert:", error);
    throw error;
  }
}
